import { Image } from 'component/Image'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { opt } from 'store/opt'
import css from './BasicLogo.module.scss'
import ChampSvg from './champ-looky.svg'
import SalarisSvg from './salaris-dresscode.svg'

type Props = {
  bottom?: boolean
}

export const BasicLogo = observer(({ bottom }: Props) => {
  const demo = useDemo()
  const { logo } = demo.product

  if (opt.foo) return <ChampSvg className={css.svg} />

  if (bottom && opt.salaris) return <SalarisSvg className={css.svg} />

  if (!logo) return null

  return <Image className={css.logo} src={logo} />
})
